var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,[React.createElement("g",{"key":0},React.createElement("path",{"fill":"#d42428","d":"M47 94c25.957 0 47-21.043 47-47S72.957 0 47 0 0 21.043 0 47s21.043 47 47 47z"})),React.createElement("g",{"key":1},React.createElement("path",{"fill":"#fff","d":"M39.4 62.154V33.65l21.54 14.252zM80 34.826C80 29.399 75.584 25 70.137 25H23.86C18.415 25 14 29.4 14 34.826v26.348C14 66.601 18.416 71 23.861 71h46.275c5.449 0 9.863-4.4 9.863-9.826V34.826z"}))])));
}

Youtube.defaultProps = {"width":"94","height":"94","viewBox":"0 0 94 94"};

module.exports = Youtube;

Youtube.default = Youtube;
